<template>
  <div class="box">
    <main>
      <img style="height: 3.5rem;" src="@/assets/footer/icon_footerlogo.png" alt="">
      <div class="content">
        <div class="content-item">
          <div class="content-item-ch">数据赋能，提升中标胜算</div>
          <div class="content-item-en">Data Empowerment Enhance the chances of winning the bid</div>
        </div>
        <div class="content-item">
          <div class="content-item-ch">一键生成，便捷高效</div>
          <div class="content-item-en">generate-project Convenient and efficient</div>
        </div>
        <div class="content-item">
          <div class="content-item-ch">专业团队，品质保障</div>
          <div class="content-item-en">professional team Quality Assurance</div>
        </div>
      </div>
      <div class="info">
        <div class="btns">
          <div class="btn" @click="$router.push('/AboutView')"><img src="@/assets/footer/icon_contact us.png" alt="">关于我们</div>
          <div class="btn" @click="$router.push('/JoinWe')"><img src="@/assets/footer/icon_join us.png" alt="">加入我们</div>
        </div>
        <!-- <div class="site">地址：河南省郑州市金水区金水东路33号(美盛中心507室)</div> -->
        <div class="contact">咨询热线：185-3817-6037</div>
      </div>
      <div class="line"></div>
      <div class="companyInfo">易信网络信息科技有限公司&ensp;&ensp;&ensp;
        <img src="@/assets/footer/putOnRecords.png" style="width: 1rem;height: 1rem;margin-right: 0.3rem;" alt="" />
        <span @click="onClickBeian" style="cursor: pointer;">豫ICP备2023009618号-1</span>
      </div>
    </main>
  </div>
</template>

<script setup name="bottomView">
import { getCurrentInstance } from 'vue'
const { proxy } = getCurrentInstance()
const { $router } = proxy
// 点击跳转ICP备案
const onClickBeian = () => {
  window.open('https://beian.miit.gov.cn/')
}
</script>
<style scoped lang="scss">
.box{
  height: 21.875rem;
  background: rgba(35, 41, 59, 1);
  padding: 2rem 0;
  position: relative;
  main {
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif !important;
    font-weight: 700!important;
    font-style: normal!important;
    .title {
      font-size: 2rem;
    }
    .content {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .content-item {
        width: 33%;
        margin: 1.8rem auto 2rem;
        .content-item-ch {
          font-size: 1.25rem;
          color: #fff;
        }
        .content-item-en {
          font-size: 0.875rem;
          margin-top: 1rem;
          color: #919191;
        }
      }
    }
    .info {
      width: 46%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.875rem;
      color: #fff;
      .btns {
        width: 13.625rem;
        height: 1.875rem;
        display: flex;
        justify-content: space-between;
        .btn {
          width: 6rem;
          height: 1.875rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.25rem;
          cursor: pointer;
          img {
            width: 1rem;
            height: 1rem;
            margin-right: 0.5rem;
          }
          &:hover {
            background: #c0252b;
          }
        }
      }
    }
    .line {
      height: 0;
      border-top: 1px solid #3A3D4A;
      border-bottom: 1px solid #141824;
      margin: 2rem 0 1.5rem;
    }
    .companyInfo{
      font-size: 0.875rem;
      color: rgba(139, 141, 148, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      span:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>
